import utils from "../common/util";

const cmpFilterHiddenTableRows = {
    component: null,

    /**
     * Initialise the modal
     * @param element
     */
    init: function (element) {
        utils.log('cmpFilterHiddenTableRows initiated : #' + element.id, 'init');

        const _ = this;
        _.component = element;
        _.filterTables = document.querySelectorAll('table[data-filter-hidden="true"]');

        _.getEmptyRows();
        _.onClickEvent(element);
    },

    /**
     * Get all empty rows in the tables and add the 'hidden' class to them.
     */
    getEmptyRows: function () {
        const _ = this;

        _.filterTables.forEach(table => {
            let rows = table.querySelectorAll('tbody tr');
            rows.forEach(row => {
                let cells = [...row.querySelectorAll('td.month-column')]
                    .filter(cell => cell.innerText === '');

                if (cells.length === 12) {
                    row.classList.add('hidden', 'empty');
                }
            });

            if(table.querySelectorAll('tbody tr').length - 1 === table.querySelectorAll('tbody tr.empty').length) {
                table.classList.add('empty', 'hidden');
            }

        });

        _.emptyRows = document.querySelectorAll('tr.empty');
    },

    /**
     * Perform actions when the toggle switch is clicked
     * @param element
     */
    onClickEvent: function (element) {
        const _ = this;

            element.addEventListener('click', (e) =>
            {
                if((e.target).checked)
                {
                    _.emptyRows.forEach(row => row.classList.remove('hidden'));
                    _.filterTables.forEach(table => table.classList.remove('hidden'));
                } else {
                    _.emptyRows.forEach(row => row.classList.add('hidden'));
                    _.filterTables.forEach(table => {
                        if(table.classList.contains('empty'))
                        {
                            table.classList.add('hidden')
                        }
                    });
                }
            });
    },
}

export default cmpFilterHiddenTableRows;
